<!-- HorizontalSlider.vue -->
<template>
  <input
    v-model="localScrollValue"
    type="range"
    :min="0"
    :max="scrollMax"
    @input="onSliderInput"
    class="slider pointer mb-3"
  />
</template>

<script>
export default {
  props: {
    scrollContainerRef: {
      type: HTMLElement,
      required: true,
    },
  },
  data() {
    return {
      localScrollValue: 0,
      scrollMax: 100,
    };
  },
  created() {
    this.calculateScrollMax();
  },
  mounted() {
    if (this.scrollContainerRef) {
      this.scrollContainerRef.addEventListener(
        "scroll",
        this.updateSliderOnScroll
      );
    }
  },
  beforeDestroy() {
    if (this.scrollContainerRef) {
      this.scrollContainerRef.removeEventListener(
        "scroll",
        this.updateSliderOnScroll
      );
    }
  },
  methods: {
    calculateScrollMax() {
      if (this.scrollContainerRef) {
        const scrollWidth = this.scrollContainerRef.scrollWidth;
        const clientWidth = this.scrollContainerRef.clientWidth;
        this.scrollMax = scrollWidth - clientWidth;
      }
    },
    onSliderInput() {
      if (this.scrollContainerRef) {
        this.scrollContainerRef.scrollLeft = this.localScrollValue;
      }
      this.$emit("input", this.localScrollValue);
    },
    updateSliderOnScroll() {
      if (this.scrollContainerRef) {
        this.localScrollValue = this.scrollContainerRef.scrollLeft;
      }
    },
  },
  watch: {
    scrollContainerRef(newVal) {
      if (newVal) {
        this.calculateScrollMax();
      }
    },
  },
};
</script>

<style scoped>
/* Add custom styles for the slider */

input[type="range"].slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px; /* Thumb width */
  height: 6px; /* Thumb height */
  background: #20639b; /* Thumb color */
  border-radius: 8px; /* Makes the thumb circular */
  cursor: pointer;
}

/* For Firefox */
input[type="range"].slider {
  -moz-appearance: none;
}

input[type="range"].slider::-moz-range-thumb {
  width: 20px; /* Thumb width */
  height: 6px; /* Thumb height */
  background: #20639b; /* Thumb color */
  border-radius: 8px; /* Makes the thumb circular */
  cursor: pointer;
}

/* General styling for compatibility across browsers */
input[type="range"].slider {
  outline: none;
  height: 6px;
}
.slider {
  -webkit-appearance: none; /* Remove default styling in WebKit browsers */
  width: 120px;
  height: 6px;
  background: #f0f0f5;
  border-radius: 8px;
  outline: none;
  transition: opacity 0.2s;
  display: flex;
  justify-content: center;
  margin: auto;
  align-items: center;
  margin-top: 10px;
}
.slider:hover {
  opacity: 1; /* Full opacity on hover */
}
</style>
